<div class="login-area" [class.dark-login-area]="themeService.isDark()">
    <div class="row m-0">
        <div class="col-lg-12 col-md-12 p-0">
            <div class="login-content">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="login-form">
                            <div class="logo" [class.d-none]="themeService.isDark()">
                                <a routerLink="/">
                                    <img src="assets/img/black-logo.png" alt="image">
                                </a>
                            </div>
                            <div class="logo d-none" [class.d-block]="themeService.isDark()">
                                <a routerLink="/">
                                    <img src="assets/img/logo.png" alt="image">
                                </a>
                            </div>

                            <h3 i18n>Welcome to Ale-Shandab Login Page</h3>

                            <div [ngClass]="invalidLogin!=''?'alert alert-danger login-message':''">
                                        <p>{{invalidLogin}}</p>
                                    </div>

                            <form [formGroup]="loginForm" (ngSubmit)="login()">
                                <div class="form-group">
                                    <input type="email" formControlName="username" id="username" placeholder="Your email address"
                                        class="form-control" required>
                                    <div *ngIf="loginFrm.username.invalid && (loginFrm.username.dirty || loginFrm.username.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="loginFrm.username.errors?.['required']">Username is required.</div>
                                        <div *ngIf="loginFrm.username.errors?.['email']">Username must be an email</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input type="password" formControlName="password" id="password" placeholder="Your password"
                                        class="form-control" required>
                                        <div *ngIf="loginFrm.password.invalid && (loginFrm.password.dirty || loginFrm.password.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="loginFrm.password.errors?.['required']">Password is required.</div>
                                    </div>

                                </div>
                                <button type="submit" i18n>Login</button>
                                <div class="forgot-password">
                                    <a routerLink="/" i18n>Forgot Password?</a>
                                </div>
                               
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>